import { appDataContext } from "@/context";
import { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "./_common/Button";

const ArticleSearchForm = (props) => {
  const JSON = useContext(appDataContext);
  const data = JSON.lang;

  return (
    <SearchFormWrapper
      id="search-articles-form"
      onSubmit={props.searchArticles}
    >
      <label
        name="search-articles"
        className="is-hidden"
        htmlFor="search-articles"
      >
        {data?.searchArticles.label}
      </label>
      <input
        type="text"
        placeholder={props.placeholder || data?.searchArticles.placeholder}
        name="search-articles"
        id="search-articles"
        value={props.searchText}
        onChange={(e) => props.setSearchText(e.target.value)}
      />
      {(props.searchText.length > 0 || props.filtered) && (
        <Button type="submit" $small id="search-articles-button">
          {props.searchText.length > 2
            ? data?.searchArticles.buttonLabel
            : data?.searchArticles.buttonLabelReset}
        </Button>
      )}
    </SearchFormWrapper>
  );
};

ArticleSearchForm.propTypes = {
  searchText: PropTypes.string,
  filtered: PropTypes.bool,
  searchArticles: PropTypes.func,
  setSearchText: PropTypes.func,
  placeholder: PropTypes.string,
};

export default ArticleSearchForm;

const SearchFormWrapper = styled.form`
  background-color: #fefefe;
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  font-family: ${(props) => props.theme.fonts.body};
  line-height: 1.2;
  margin-bottom: 1.6rem;
  @media screen and (min-width: 768px) {
    font-size: 3.2rem;
    margin-bottom: 32px;
  }
  margin-left: auto;
  margin-right: auto;
  padding: 0 0;
  overflow: unset;
  position: relative;
  width: calc(100% - 60px);
  max-width: 80%;
  z-index: 10;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  grid-column: 1 / -1;
  &:focus-within {
    outline: 0;
    border: 2px solid ${(props) => props.theme.colors.green} !important;
    button {
      box-shadow: 0 0 0 1px ${(props) => props.theme.colors.green};
    }
  }
  input {
    flex-grow: 2;
    width: 90%;
    padding-left: 1rem;
    padding-right: 1rem;
    border: none;
    outline: 0;
    border-radius: 0 4px 4px 0;
    font-size: 1.6rem;
    padding-bottom: 1rem;
    padding-top: 1rem;
    display: table-cell;
    margin: 0;
    vertical-align: middle;
    white-space: nowrap;

    &:focus {
      outline: 0;
      outline-color: transparent !important;
    }
  }

  button {
    border-style: none !important;
    outline: 0;
    border-radius: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    margin: -20px auto;
    padding: -20px 3px;
    background-color: ${(props) => props.theme.colors.green};
    color: #fefefe;
    border-radius: 4px 0 0 4px;
    font-family: ${({ theme }) => theme.fonts.body};
    font-weight: 400;
    white-space: nowrap;
    &:focus {
      background-color: ${(props) => props.theme.colors.green};
    }
  }
`;
